import { ReactNode } from "react"
import { Block, IconProps, Mats, useStyletron } from "@mezo-org/mezo-clay"

type RewardMatsProps = {
  label: ReactNode
  iconPosition?: "prefix" | "suffix"
  iconSize?: number
}

export default function MatsReward({
  label,
  iconPosition = "suffix",
  iconSize = 14,
}: RewardMatsProps) {
  const [css, theme] = useStyletron()

  const iconProps: IconProps = {
    size: iconSize,
    color: theme.colors.contentPrimary,
  }

  return (
    <Block
      className={css({
        display: "flex",
        alignItems: "center",
        gap: theme.sizing.scale100,
      })}
    >
      {iconPosition === "prefix" && <Mats {...iconProps} />}
      {label}
      {iconPosition === "suffix" && <Mats {...iconProps} />}
    </Block>
  )
}
